export function getDataRoomIndex(
  sortIndex: number | undefined,
  parentFolders: Array<{
    id: string;
    index?: {
      sortIndex: number;
    } | null;
  }>,
  type: "folder" | "file",
): string {
  if (!sortIndex) return "";

  if (type === "folder") {
    let orderedParents = [...parentFolders].reverse().slice(1);
    return orderedParents
      .reduce((acc, parent) => {
        return acc + (parent.index?.sortIndex.toString() || "") + ".";
      }, "")
      .slice(0, -1);
  }

  if (type === "file") {
    let orderedParents = [...parentFolders].reverse().slice(1);
    let builtIndex = orderedParents
      .reduce((acc, parent) => {
        return acc + (parent.index?.sortIndex.toString() || "") + ".";
      }, "")
      .slice(0, -1);
    if (builtIndex.length > 0) {
      builtIndex = builtIndex + ".";
    }
    builtIndex = builtIndex + (sortIndex.toString() || "");
    return builtIndex;
  }

  return "";
}
